import Vue from "vue";
import VueRouter from "vue-router";
import Inicio from "../views/InicioView.vue";
import auth from "@/auth/auth";
import authDir from "@/auth/authDirecto";
import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/LoginView.vue"),
    meta: {
      requiresAuth: false
    },
    children: [
      {
        path: "crear-contrasena/:id_cliente",
        name: "crear_contrasena",
        component: () => import("../components/login/RecuperarClave.vue")
      }
    ]
  },
  {
    path: "/inicio",
    name: "ingresa",
    component: Inicio,
    meta: {
      titulo: "Inicio",
      requiresAuth: true,
      requireMenu: true
    }
  },
  {
    path: "/productos/:product",
    name: "productos",
    component: () => import("../views/ProductosView.vue"),
    meta: {
      requiresAuth: true,
      requireMenu: true
    }
  },
  {
    path: "/proximos-pagos",
    name: "proximos-pagos",
    component: () => import("../views/ProximosPagosView.vue"),
    meta: {
      titulo: "Próximos Pagos",
      requiresAuth: true,
      requireMenu: true
    }
  },
  {
    path: "/cuenta/:ajuste",
    name: "cuenta",
    component: () => import("../views/CuentaView.vue"),
    meta: {
      titulo: "Cuenta",
      requiresAuth: true
    }
  },
  {
    path: "/ultimas-novedades",
    name: "ultimas-novedades",
    component: () => import("../views/NovedadesView.vue"),
    meta: {
      titulo: "Últimas Novedades",
      requiresAuth: true,
      requireMenu: true
    }
  },
  {
    path: "/curso-cooperativismo",
    name: "curso-cooperativismo",
    component: () => import("../views/CursoCooperativismo.vue"),
    meta: {
      titulo: "Curso de Cooperativismo",
      requiresAuth: true,
      requireMenu: true
    }
  },
  {
    path: "/descarga-documentos",
    name: "descarga-documentos",
    component: () => import("../views/DescargaDocumentosView.vue"),
    meta: {
      titulo: "Descarga de Documentos",
      requiresAuth: true,
      requireMenu: true
    }
  },
  {
    path: "/cuotas-participacion",
    name: "cuotas-participacion",
    component: () => import("../views/CuotasParticipacionView.vue"),
    meta: {
      titulo: "Cuotas de Participación",
      requiresAuth: true,
      requireMenu: true,
      requiresBit: "b_socio"
    }
  },
  {
    path: "/documentos-firmar",
    name: "documentos-firmar",
    component: () => import("../views/DocumentosFirmarView.vue"),
    meta: {
      titulo: "Documentos para Firmar",
      requiresAuth: true,
      requireMenu: true
    }
  },
  {
    path: "/contactanos",
    name: "contacto",
    component: () => import("../views/ContactoView.vue"),
    meta: {
      titulo: "Formularios",
      requiresAuth: true,
      requiresParam: "mostrar_contactanos"
      // requireMenu: true
    }
  },
  {
    path: "/pago-productos",
    name: "pago-productos",
    component: () => import("../views/PagoProductosView.vue"),
    meta: {
      titulo: "Pago Productos",
      requiresAuth: true,
      requireMenu: true
    }
  },
  {
    path: "/simulador-dap",
    name: "simulador-dap",
    component: () => import("../views/SimuladorDapView.vue"),
    meta: {
      titulo: "Pago Productos",
      requiresAuth: true,
      requireMenu: true
    }
  },
  {
    path: "/mantencion",
    name: "mantencion",
    component: () => import("../views/MantencionView.vue")
  },
  {
    path: "/pago-directo",
    name: "pago-directo",
    component: () => import("../views/LoginDirectoView.vue"),
    meta: {
      requiresAuth: false,
      requiresDirectoAuth: false,
      pagoDirecto: true
    },
    children: [
      {
        path: "productos",
        name: "pago-directo-productos",
        component: () => import("../views/PagoDirectoView.vue"),
        meta: {
          requiresDirectoAuth: true,
          pagoDirecto: true
        }
      }
    ]
  },
  {
    path: "/contratar-productos/:product",
    name: "contratar-productos",
    component: () => import("../views/ContratarProductosView.vue"),
    meta: {
      requiresAuth: true,
      requireMenu: true
    }
  },
  {
    path: "/codigo-2fa",
    name: "codigo-2fa",
    component: () => import("../views/Codigo2FAView.vue"),
    meta: {
      requiresAuth: false,
      hideAppChrome: true
    }
  },

  {
    path: "/",
    redirect: "/inicio"
  },
  {
    path: "*",
    redirect: "/inicio"
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  //Lógica que se ejecuta antes de renderizar la ruta a la vista respectiva
  //Primero se debe validar si la ruta requiere autenticación
  if (to.name === "mantencion") {
    if (store.state.parametros.mantencion) next();
    else next("/");
    return;
  } else if (to.matched.some((record) => record.meta.pagoDirecto)) {
    let pagoDirecto = store.state.parametros.pago_directo;
    if (pagoDirecto) {
      if (to.matched.some((record) => record.meta.requiresDirectoAuth)) {
        if (authDir.isAuthenticated()) return next();
        else return next("/pago-directo");
      } else {
        if (authDir.isAuthenticated()) return next("/pago-directo/productos");
        else return next();
      }
    } else {
      store.dispatch("mostrarAlerta", {
        mensaje: "Pago Directo no disponible por el momento, intente más tarde",
        color: "error"
      });
      return next("/");
    }
  } else if (to.name !== "mantencion" && store.state.parametros.mantencion) {
    next("/mantencion");
    return;
  } else {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      //Si la ruta requiere autenticación se valida si el usuario está autenticado
      
      // ruta que cambia los datos de contacto
      if (to.path == "/cuenta/seleccion-cambio-datos-contacto") {

        // valida que la ruta tenga un queryparam de token
        var token = to.query?.token
        if (token == undefined || token == null || token == "") {
          if (auth.isAuthenticated()) {
            await store.dispatch("updateCounter", {
              accion: 2,
              clien_s_id: auth.getUserLogged().id_cliente
            });
          }
          let bit_datos_contacto = store.state.userCounter.datos_contacto;
          if(bit_datos_contacto <= 0 || bit_datos_contacto == undefined || bit_datos_contacto == null) {
            await auth.cerrarSesion();
            return next();
          }
        } else {
          // validacion de token
          if (!(await auth.verificarToken(token))) {
            await auth.cerrarSesion();
            return next();
          }
        }

        // si no esta loggeado se debe ingresar al loggin? no se, pero lo hare de todas formas
        if (!auth.isAuthenticated()) {
          // Guardamos la ruta original para redirigir después del login
          return next({
            path: '/login',
            query: {
              redirect: to.fullPath
            }
          });
        }
        // todo bien, sigue a la ruta original
        return next();
      }
      
      if (auth.isAuthenticated()) {
        store.dispatch("updateCounter", {
          accion: 2,
          clien_s_id: auth.getUserLogged().id_cliente
        });

        //Si el usuario está autenticado se valida si el usuario debe cambiar su clave
        let cambio_clave = auth.getUserLogged().b_cambiar_clave;
        if (cambio_clave) {
          if (to.path === "/cuenta/cambiar-clave") next();
          else next("/cuenta/cambiar-clave");
          return;
        }
        //Si el usuario no debe cambiar su clave se realizan otras validaciones según la ruta a la que desee acceder y sus precondiciones
        else {
          if (to.path === "/contactanos") {
            if (store.state.parametros.mostrar_contactanos) return next();
            else return next("/");
          }
          if (to.matched.some((record) => record.meta.requireMenu)) {
            let route = to.name;
            let menus = store.state.secciones;
            let exists = menus.some((item) => item.route === route);
            if (!exists) {
              store.dispatch("mostrarAlerta", {
                mensaje: "El menú al que intenta acceder no está disponible",
                color: "error"
              });
              return next("/");
            } else {
              if (to.matched.some((record) => record.meta.requiresBit)) {
                let bit = to.meta.requiresBit;

                if (store.state.userBits[bit]) {
                  next();
                } else {
                  next("/");
                }
              } else {
                if (to.name === "documentos-firmar") {
                  let firma = to.query.firma;
                  let dap = to.query.dap;
                  let lac = to.query.lac;
                  let epac = to.query.epac;
                 console.log(firma, dap, lac, epac);
                  if (firma) {
                    if (firma === "ok") localStorage.setItem("firma", "1");
                    else if (firma === "traza")
                      localStorage.setItem("firma", "2");
                    else localStorage.setItem("firma", "0");
                    
                    if (dap) localStorage.setItem("dap", dap);
                    if (lac) localStorage.setItem("lac", lac);
                    if (epac) localStorage.setItem("epac", epac);
                    next({
                      path: "/documentos-firmar",
                      replace: true
                    });
                  } else {
                    next();
                    return;
                  }
                } else {
                  next();
                  return;
                }
              }
            }
          } else {
            next();
            return;
          }
        }
      }
      //Si el usuario no está autenticado se redirige a la ruta de login
      else {
        // Guardamos la ruta original para redirigir después del login
          return next({
            path: '/login',
            query: {
              redirect: to.fullPath
            }
          });
      }
    }
    //Si la ruta no requiere autenticación se valida si el usuario está autenticado para redirigirlo a la ruta de inicio
    else {
      if (auth.isAuthenticated()) {
        next("/ingresa");
        return;
      } else {
        next();
      }
    }
  }
});

export default router;
